import React from 'react';
import Dropdown from './Dropdown';
import { DefaultDropdownProps } from './dropdownHelper';

export interface EnumDropdownProps extends Omit<DefaultDropdownProps, 'options'> {
  options: Dictionary<string>;
}

const EnumDropdown = ({ options, placeholder = 'Select status', ...props }: EnumDropdownProps) => {
  return (
    <Dropdown
      {...props}
      placeholder={placeholder}
      options={Object.keys(options).map(key => ({
        value: key,
        label: options[key],
      }))}
    />
  );
};

export default EnumDropdown;
